<template lang='pug'>
.cp-home
  .page1
    .introduce-wrap.w
      img.bg(src="../../assets/banner1.png")
      .introduce
        p “大数据、多场景、强互动”融合
        p 基于数据智能化运营的全链路营销增效平台
        p 立足企业市场，以用户经营场景构建服务，成为企业客户数据智能营销的坚实伙伴
        //- a.banner-btn(@click="scollPage")
        //-   span 了解更多
        //-   icon.icon(iconClass="icongengduo-white")
    .banner#banner
      p 融合“数据、场景、互动”
      p 形成全新的智能化精准营销通路
  .page2
    feature-list(@showModal="showModal")
  .page3
    .bg
    .content-wrap.w
      .wrap
        number-list#numlist(ref="number-list")
        .apply-wrap
          .title 数据智能化经营的典型要素
          .subtitle 用户运营周期全覆盖
          .video-wrap
            video#video1(src="../../../public/首页视频2.mp4" width="1920" autoplay="autoplay" loop="loop" muted="muted")
        .wrap
          .title 智能化营销通路
           // #TODO 需要更换图片
          img.w(src="../../assets/home1.png",style="margin:130px auto 207px")
  page-belt(@showModal="showModal")
</template>

<script>
import featureList from './components/feature-list'
import numberList from './components/number-list'
import audioList from './components/audio-list'
import newsList from './components/news-list'
import talkList from './components/talk-list'
import { checkVisible } from '@/common/utils'
export default {
  name: 'home',
  components: {
    featureList,
    numberList,
    audioList,
    newsList,
    talkList,
  },
  methods: {
    bindScrollListener () {
      window.addEventListener('scroll', this.scrollCallback)
    },
    scollPage () {
      document.getElementById('banner').scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    scrollCallback () {
      const numList = document.getElementById('numlist')
      if (checkVisible(numList)) {
        this.$refs['number-list'].start()
      } else {
        this.$refs['number-list'].reset()
      }
    },
    showModal (isShow) {
      this.$emit('showModal', isShow)
    }
  },
  mounted () {
    this.bindScrollListener()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollCallback)
  }
}
</script>
<style lang="stylus">
@import 'config'
.cp-home
  background #0b1c44
  .page1
    background #000725
    overflow hidden
    .introduce-wrap
      position relative
      padding-left 20px
      .bg
        position absolute
        z-index 0
        left -350px
        width 1920px
        height 980px
      .introduce
        position relative
        z-index 1
        padding-top 278px
        p
          &:first-child
            font-size 26px
            color #9EEAFA
            margin-bottom 8px
          &:nth-child(2)
            font-size 36px
            color #FFFFFF
            margin-bottom 15px
          &:nth-child(3)
            font-size 16px
            color #D5DCEC
            width 389px
      .banner-btn
        display block
        width 200px
        height 50px
        line-height 48px
        margin-top 38px
        text-align center
        background #16AABA
        color #FFFFFF
        border-radius 5px
        border 1px solid rgba(98,242,255,1)
        font-size 18px
        font-weight 600
        transition all .5s
        cursor pointer
        &:hover
          background #1ad1e4
        .icon
          margin-left 5px
        span
          font-size 18px
    .banner
      position relative
      z-index 1
      height 185px
      background linear-gradient(360deg,rgba(0,17,78,1) 0%,rgba(12,32,79,0.6) 100%)
      margin-top 282px
      padding-top 53px
      line-height 1.5
      text-align center
      p
        color #9EEAFA
        font-size 24px
  .page3
    position relative
    .bg
      position absolute
      top 0
      width 100%
      height 750px
      left 0
      background url('../../assets/plane.jpg') no-repeat
      background-position bottom 0 left 0
      background-size cover
    .content-wrap
      padding-top 200px
      position relative
      //.bg
      //  width 1920px
      //  z-index 0
      .wrap
        position relative
        z-index 1
        .apply-wrap
          margin-top 276px
          .video-wrap
            padding 40px 0 100px
            position relative
            &::before,
            &::after
              position absolute
              content ''
              height 120px
              width 1920px
              left -360px
            &::before
              top 0
              background linear-gradient(0deg,rgba(11,28,68,0) 0%,rgba(11,28,68,1) 100%)
            &::after
              bottom 0
              background linear-gradient(180deg,rgba(11,28,68,0) 0%,rgba(11,28,68,1) 100%)
            video
              margin-left -360px

  .page4
    .content-wrap
      position relative
      .bg
        position absolute
        top 0
        left -400px
        width 2026px
        height 1075px
        z-index 0
      .audio
        position relative
        z-index 1
</style>
